import {
  UNSUBSCRIBE_NEWSLETTER,
  RESET_UNSUBSCRIBE_NEWSLETTER,
} from "../types/newsletter/unsubscribe";

interface NewsletterState {
  unsubscribe: {
    data: any;
    states: {
      loading: boolean;
      success: boolean;
      error: boolean;
    };
  };
}

const initialState: NewsletterState = {
  unsubscribe: {
    data: null,
    states: {
      loading: false,
      success: false,
      error: false,
    },
  },
};

const newsletterReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case UNSUBSCRIBE_NEWSLETTER:
      return {
        ...state,
        unsubscribe: {
          ...state.unsubscribe,
          states: {
            loading: true,
            success: false,
            error: false,
          },
        },
      };

    case `${UNSUBSCRIBE_NEWSLETTER}_SUCCESS`:
      return {
        ...state,
        unsubscribe: {
          data: action.payload,
          states: {
            loading: false,
            success: true,
            error: false,
          },
        },
      };

    case `${UNSUBSCRIBE_NEWSLETTER}_ERROR`:
      return {
        ...state,
        unsubscribe: {
          ...state.unsubscribe,
          states: {
            loading: false,
            success: false,
            error: true,
          },
        },
      };

    case RESET_UNSUBSCRIBE_NEWSLETTER:
      return {
        ...state,
        unsubscribe: {
          data: null,
          states: {
            loading: false,
            success: false,
            error: false,
          },
        },
      };

    default:
      return state;
  }
};

export default newsletterReducer; 